import { useEffect, useState } from 'react'
import moment from 'moment'
import { AccordionIcon } from './'
import { CheckboxButton, CheckboxButtonGroup, InputEntidad, FormLabel, FormError } from '../../../components/common'
import { OPERATION_MODE, REQUEST_METHOD } from '@laramie/ui';
import { APIS } from '../../../config/apis'
import { standardRequest } from '../../../utils/requests'
import { getDateToString } from '../../../utils/convert'
import {TIPS} from "../../../consts/tips";

const Vencimientos = ({ toggle, open, formValues, setFormValues, setPendingChange, handleInputProxy, errorOf, params }) => {
    const [tiposVencimiento, setTiposVencimiento] = useState([])
    const [tiposVencimientoEncadenados, setTiposVencimientoEncadenados] = useState(null)

    const tipoVencimientoAnticipo = tiposVencimiento.find(row => row.id === formValues.idTipoVencimientoAnticipo) ?? null
    const tipoVencimientoCuota1 = tiposVencimiento.find(row => row.id === formValues.idTipoVencimientoCuota1) ?? null

    const fechaVencimientoAnticipo = (formValues.vencimientoEncadenado && formValues.idTipoVencimientoAnticipo > 0 && tipoVencimientoAnticipo?.fechaVencimiento)
        ? moment(tipoVencimientoAnticipo.fechaVencimiento).format('YYYY-MM-DD')
        : null

    useEffect(() => {
        standardRequest(REQUEST_METHOD.GET, APIS.URLS.TIPO_VENCIMIENTO_PLAN_PAGO)
            .then(data => setTiposVencimiento(data ?? []))
            .catch(() => setTiposVencimiento([]))
    }, [])

    useEffect(() => {
        if (!fechaVencimientoAnticipo) {
            setTiposVencimientoEncadenados(null)
            return
        }
        let vigente = true
        standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.TIPO_VENCIMIENTO_PLAN_PAGO}/fecha-vencimiento-anterior/${encodeURIComponent(fechaVencimientoAnticipo)}`)
            .then(data => {
                if (vigente) setTiposVencimientoEncadenados(data ?? [])
            })
            .catch(() => {
                if (vigente) setTiposVencimientoEncadenados(null)
            })
        return () => { vigente = false }
    }, [fechaVencimientoAnticipo])

    const filtroCuota1SinEncadenar = (row) => (row.baseDiaActual || row.baseDiaFinMes) && row.planPago

    const handleVencimientoEncadenado = ({ target }) => {
        const descartaCuota1 = !target.checked && tipoVencimientoCuota1 && !filtroCuota1SinEncadenar(tipoVencimientoCuota1)
        setFormValues({
            ...formValues,
            vencimientoEncadenado: target.checked,
            idTipoVencimientoCuota1: descartaCuota1 ? 0 : formValues.idTipoVencimientoCuota1
        })
        setPendingChange(true)
    }

    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon {...{open}} />
                        <h3 className={open ? 'active' : ''}>Vencimientos</h3>
                    </div>
                </div>
            </div>
        </div>

        {open && (
            <div className='accordion-body'>
                <div className='row form-basic'>
                    <div className="col-12">
                        <CheckboxButtonGroup>
                            <CheckboxButton
                                name="vencimientoEncadenado"
                                label="Vencimiento encadenado"
                                checked={formValues.vencimientoEncadenado}
                                onChange={handleVencimientoEncadenado}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                        </CheckboxButtonGroup>
                    </div>
                </div>
                <div className='row form-basic'>
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="idTipoVencimientoAnticipo" required>Vencimiento anticipo</FormLabel>
                        <InputEntidad
                            name="idTipoVencimientoAnticipo"
                            tipName={TIPS.NAME.MODALS.TIPO_VENCIMIENTO_PLAN_PAGO_MODAL}
                            placeholder=""
                            className={`form-control ${errorOf('idTipoVencimientoAnticipo') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoVencimientoAnticipo}
                            onChange={handleInputProxy}
                            entidad="TipoVencimientoPlanPago"
                            title="Tipo de vencimiento para el anticipo"
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            columns={[
                                { Header: 'Descripción', accessor: 'descripcion', width: '75%' },
                                { Header: 'Ej. fecha venc.', Cell: (data) => getDateToString(data.value), accessor: 'fechaVencimiento', width: '20%' }
                            ]}
                            filter={(row) => (row.baseDiaActual || row.baseDiaFinMes) && row.planPago}
                            data={tiposVencimiento}
                            memo={null}
                        />
                        <FormError message={errorOf('idTipoVencimientoAnticipo')} />
                    </div>
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="idTipoVencimientoCuota1" required>Vencimiento primera cuota</FormLabel>
                        <InputEntidad
                            name="idTipoVencimientoCuota1"
                            tipName={TIPS.NAME.MODALS.TIPO_VENCIMIENTO_PLAN_PAGO_MODAL}
                            placeholder=""
                            className={`form-control ${errorOf('idTipoVencimientoCuota1') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoVencimientoCuota1}
                            onChange={handleInputProxy}
                            entidad="TipoVencimientoPlanPago"
                            title="Tipo de vencimiento para la cuota 1"
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            columns={formValues.vencimientoEncadenado
                                ? [
                                    { Header: 'Descripción', accessor: 'descripcion', width: '55%' },
                                    { Header: 'Ej. sin anticipo', Cell: (data) => getDateToString(data.value), accessor: 'fechaVencimiento', width: '20%' },
                                    { Header: 'Ej. con anticipo', Cell: (data) => getDateToString(data.value), accessor: 'fechaVencimientoConAnticipo', width: '20%' }
                                ]
                                : [
                                    { Header: 'Descripción', accessor: 'descripcion', width: '75%' },
                                    { Header: 'Ej. fecha venc.', Cell: (data) => getDateToString(data.value), accessor: 'fechaVencimiento', width: '20%' }
                                ]
                            }
                            filter={(row) => formValues.vencimientoEncadenado ? row.planPago : filtroCuota1SinEncadenar(row)}
                            data={tiposVencimientoEncadenados ?? tiposVencimiento}
                            memo={null}
                        />
                        <FormError message={errorOf('idTipoVencimientoCuota1')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="idTipoVencimientoCuotas" required>Vencimiento cuotas restantes</FormLabel>
                        <InputEntidad
                            name="idTipoVencimientoCuotas"
                            tipName={TIPS.NAME.MODALS.TIPO_VENCIMIENTO_PLAN_PAGO_MODAL}
                            placeholder=""
                            className={`form-control ${errorOf('idTipoVencimientoCuotas') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoVencimientoCuotas}
                            onChange={handleInputProxy}
                            entidad="TipoVencimientoPlanPago"
                            title="Tipo de vencimiento para el resto de las cuotas"
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            columns={[
                                { Header: 'Descripción', accessor: 'descripcion', width: '95%' }
                            ]}
                            filter={(row) => row.planPago}
                            data={tiposVencimiento}
                            memo={null}
                        />
                        <FormError message={errorOf('idTipoVencimientoCuotas')} />
                    </div>
                </div>
            </div>
        )}
    </>
}

export default Vencimientos
